import { QUESTION_TYPE_LABELS } from "../../DecisionQuestionsEditor/utils";

import { DecisionQuestion } from "@/types/prompt-blueprint";

export const DecisionQuestionsPreview = ({ questions }: { questions: DecisionQuestion[] }) => (
  <div className="flex flex-col gap-2 pt-1">
    <p className="py-1.5 text-sm text-muted-foreground">Decisions API questions</p>
    {questions.map(question => (
      <div key={question.name} className="rounded-md border border-gray-200 px-3 py-2">
        <div className="flex items-center justify-between gap-2">
          <span className="font-mono text-sm text-gray-900">{question.name}</span>
          <span className="text-xs text-gray-500">{QUESTION_TYPE_LABELS[question.type]}</span>
        </div>
        <p className="mt-1 text-sm text-gray-700">{question.instructions}</p>
        {question.options?.length ? (
          <p className="mt-1 text-xs text-gray-500">
            {question.options.map(option => String(option.value)).join(" · ")}
          </p>
        ) : null}
      </div>
    ))}
  </div>
);
